<template>
  <div>
    <Header />
    <div style="padding-top: 2rem; text-align: center" class="beer">
      <img
        :src="'/assets/img/beers/' + itemName +'.svg'"
        style="
          margin-top: 0rem;
          margin-bottom: 1rem;
          max-width: 300px;
          min-width: 150px;
          width: 100%;
        "
      />
      <ItemFunctions :item="item" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Header from "../templates/Header";
import ItemFunctions from "./../components/ItemFuncitons";
export default {
  name: "Beer",
  components: { Header, ItemFunctions },
  data: () => ({
    item: { variants: [] },
  }),
  props: ['itemId', 'itemName', 'title'],
  created() {
    var self = this;
    fetch(this.$apipath + "/api/items/" + this.itemId)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return response.text().then((text) => {
            throw new Error("\nHTTP " + response.status + " - " + text);
          });
        }
      })
      .then((data) => {
        self.item = data;
      })
      .catch((err) => {
        self.$store.commit("addNotification", {
          text: "Chyba načtení položky. " + err.message,
          type: "alert",
        });
      });
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: "og:image",
          property: "og:image",
          content: "https://hoppyhedgehog.cz/assets/img/og/"+ this.itemName+'.png',
        },  
        { vmid: "og:title", property: "og:title", content: this.title },
        {
          vmid: "og:url",
          property: "og:url",
          content: "https://hoppyhedgehog.cz/"+ this.itemName,
        },
      ],
    };
  },
};
</script>
